<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Lien de paiement -->
        <section id="content-8" class="wide-60 content-section division sct_tuto  grey_bck_section">
            <div class="container">	


                <!-- SECTION TITLE 	-->	
                <div class="row">	
                    <div class="col-lg-10 offset-lg-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">TPE Virtuelle<br> APAYM</h2>	

                        <!-- Text -->
                        <p></p>
                                
                    </div>	
                </div> 	 <!-- END SECTION TITLE -->	


                <div class="row">
                    <div class="col-md-12">
                    


                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-txt ind-45"> 
                                            
                                            <p>Le TPE virtuelle APAYM est un QR code sécurisé à usage unique qui accepte à la fois les paiements par carte bancaire et mobile money.</p>
                                        

                                            <p>Le client, lors de son passage en caisse, peut désormais scanner le QR code du marchand APAYM PRO depuis l’appareil photo de son smartphone
                                                 et choisir le moyen  de paiement qui lui sied (cartes bancaires ou mobile money).</p>

                                            <p>Le marchand APAYM PRO peut utiliser un seul QR code pour tous ses services et son QR code n'expire jamais.</p>
                                            <p>Une fois configuré, le marchand peut l’utiliser aussi longtemps qu’il le souhaite</p>


                                            <!-- Text -->	
                                            <p class="">
                                            <!-- Button -->						
                                            <a href="#contacts-2" class="btn btn-lightorange">Créer un compte Pro</a>                    
                                            </p>

                                            </div>	
                                            

                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid" src="@/assets/images/tpe-virtuelle.png" width="500" alt="content-image">
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>	
                </div>     <!-- End row -->	
            </div>     <!-- End container -->	
        </section>
        <!-- Lien de paiement-->

      

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'nos_cartes',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}


</script>

<style scoped>
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}

</style>

